const ClarityPlugin = {
  name: 'Clarity',

  install (Vue, options = {}) {
    const { id } = options
    if (!id) {
      console.warn('Microsoft Clarity ID não fornecido')
      return
    }

    function initializeClarity () {
      (function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) }
        t = l.createElement(r)
        t.async = 1
        t.src = 'https://www.clarity.ms/tag/' + i
        y = l.getElementsByTagName(r)[0]
        y.parentNode.insertBefore(t, y)
      })(window, document, 'clarity', 'script', id)
    }

    initializeClarity()

    Vue.prototype.$clarity = {
      iniciar: initializeClarity
    }
  }
}

export default ClarityPlugin
